angular.
module("dx.webapp.invigilator", [
	"dx.webapp.validation",

	"dx.ui.utils",
	"dx.ui.components.localize",

	"digiexam.services",
]);
